import styled from "styled-components";
import Tooltip from "../../../../base/others/tooltip/index.js";
import { TooltipContent } from "../../../../base/others/tooltip/styled.js";
import { FontMixin } from "../../../../../styles/common/mixins/helpers.styled.js";
import { Border, BorderRadius, Padding } from "../../../../../styles/common/mixins/logical.styled.js";
import calendarInputThemes from "./themes/index.js";
export const CalendarInput = styled.input.withConfig({
    displayName: "styled__CalendarInput",
    componentId: "sc-e4a3fa39-0"
})`
	--outline-color-default: ${({ theme  })=>theme.colors.white.base};
	--outline-color-active: ${({ theme  })=>theme.colors.primary.light};
	--outline-color-error: ${({ theme  })=>theme.colors.status.error};
	--outline-color-focused: ${({ theme  })=>theme.colors.primary.light};
	--outline-width: 2px;
	--input-height: 56px;

	${Border({
    all: '0'
})};
	${BorderRadius({
    all: '4px'
})};
	${FontMixin({
    size: 'medium',
    height: 'base',
    weight: 'regular'
})};
	${Padding({
    top: '24px',
    right: '42px',
    bottom: '8px',
    left: '12px'
})};
	background: ${({ theme  })=>theme.colors.white.base};
	color: ${({ theme  })=>theme.colors.grays.darker};
	min-height: var(--input-height);
	text-align: left;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 100%;

	&:disabled {
		color: ${({ theme  })=>theme.colors.grays.base};
		font-weight: ${(props)=>props.theme.font.weight.light};
		cursor: not-allowed !important;
	}

	outline: none;
	transition: outline 0.1s linear;

	&.active {
		outline: var(--outline-width) solid var(--outline-color-active);
	}

	${({ $hasError  })=>$hasError ? 'outline: var(--outline-width) solid var(--outline-color-error)' : ''};
	${({ $isFocused  })=>$isFocused ? 'outline: var(--outline-width) solid var(--outline-color-focused)' : ''};

	${({ theme  })=>calendarInputThemes[theme.id]?.CalendarInput?.()}
`;
export const ErrorTooltip = styled(Tooltip).withConfig({
    displayName: "styled__ErrorTooltip",
    componentId: "sc-e4a3fa39-1"
})`
	--tooltip-background: ${({ theme  })=>theme.colors.status.error};
	--tooltip-color: ${({ theme  })=>theme.colors.white.base};

	${({ $width  })=>$width && `--tooltip-min-width: ${$width}px;`}
	--tooltip-max-width: 100%;

	${TooltipContent} {
		${FontMixin({
    size: 'small',
    height: 'base',
    weight: 'regular'
})}
		text-align: left;
	}
`;

//# sourceMappingURL=styled.js.map